import React, { useState } from 'react';
import './FloatingWidget.css';

const FloatingWidget = () => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <div className={`floating-widget-container ${isOpen ? 'open' : ''}`}>
            {isOpen && (
                <div className="widget-content">
                    <div className="widget-header">
                        <h3>Get in Touch</h3>
                        <button onClick={() => setIsOpen(false)} className="close-btn">×</button>
                    </div>
                    <div className="widget-body">
                        <p>Ready to automate your operations? Let's discuss your project.</p>
                        <a href="mailto:geraldezjohn29@gmail.com" className="contact-link">
                            geraldezjohn29@gmail.com
                        </a>
                        <button className="schedule-btn" onClick={() => window.open('mailto:geraldezjohn29@gmail.com')}>
                            Schedule a Meeting
                        </button>
                    </div>
                </div>
            )}

            <button className="widget-toggle" onClick={() => setIsOpen(!isOpen)}>
                {isOpen ? 'Close' : 'Schedule a Meeting'}
            </button>
        </div>
    );
};

export default FloatingWidget;
